export default __webpack_public_path__ + "static/media/hoitokeskustelut.22e9a08c.jpg";